import { Component, OnInit, AfterViewInit, ViewChild, Input, NgZone } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import { Util } from '../../../shared/utils/util';
import { ConsultaPreviaService } from '../../../shared/services/consulta-previa.service';
import { MessageService } from '../../../shared/messages/message.service';
import { ConsultaPreviaModel } from '../../../shared/models/consulta-previa.model';

import { AuthenticationService } from '../../../core/authentication/authentication.service';
import { DropdownListService } from '../../../shared/services/dropdownlist.service';
import { ToastrService } from 'ngx-toastr';

import { delay } from 'rxjs/operators';
import { ContatoComercialService } from '../../../shared/services/contato-comercial.service';
import { IsOptionValidValidator } from '../../../shared/validators/isoption-valid.validator';
import { Router } from '@angular/router';
import { IMultiSelectSettings, IMultiSelectTexts, MultiselectDropdownComponent } from 'angular-2-dropdown-multiselect';
import { GerarSolicitacaoService } from './gerar-solicitacao.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IsNullOrEmptyValidator } from '../../validators/isnull-or-empty.validator';
import { PageEnum } from '../../models/page-enum.model';
import { ProdutoTipoEnum } from '../../../shared/models/produto-tipo-enum';
import { environment } from '../../../../environments/environment';
import { EndpointLocationProviderService } from '../../services/endpoint-location-provider.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'gerar-solicitacao',
  templateUrl: './gerar-solicitacao.component.html',
  styleUrls: ['./gerar-solicitacao.component.scss'],
  providers: [GerarSolicitacaoService]
})
export class GerarSolicitacaoComponent implements OnInit, AfterViewInit {

  public steps: any[];
  public dadosIdentificacaoTitular: FormGroup;
  public tipoDocumentoIdentidade: FormGroup;
  public conectividadeSocial: FormGroup;
  public tituloEleitor: FormGroup;
  public informacoesComerciais: FormGroup;
  public enderecoIdentificacao: FormGroup;
  public dadosIdentificacaoNota: FormGroup;
  public dadosEnvioNota: FormGroup;
  public enderecoNota: FormGroup;
  public pagamento: FormGroup;
  public schedule: FormGroup;

  @ViewChild('selectProduto', { static: false }) private selectProduto: MultiselectDropdownComponent;
  @ViewChild('selectAutoridadeRegistro', { static: false }) private selectAutoridadeRegistro: MultiselectDropdownComponent;

  @Input() paginaPai: any;

  PageEnum = PageEnum;

  // Mensagens de validações
  MSG_CAMPO_OBRIGATORIO = Util.getMensagemCampoObrigatorio();
  MSG_CAMPO_INVALIDO = Util.getMensagemCampoInvalido();
  MSG_CAMPO_CARACTERESESPECIAIS = Util.getMensagemCampoCaracteresEspeciais();
  lastFilter: any;
  listaProdutos = [];
  listaProdutosFiltro = [];
  listaContatoComercial = [];
  listaACs = [];
  listaARs = [];
  retornoAdd: any;
  retornoCupom: any;
  env: any;
  CnpjAR = '';

  isSafeweb = location.host.toString().includes('acsafeweb') || location.host.toString().includes('localhost');

  private setouDadosNFe = false;

  private endereco;
  private quantidadeLoadedStates = 0;
  private quantidadeLoadedCities = 0;
  private quantidadeLoadedCountries = 0;

  private enderecoEmpresa;
  private quantidadeLoadedStatesEmpresa = 0;
  private quantidadeLoadedCitiesEmpresa = 0;
  private quantidadeLoadedCountriesEmpresa = 0;

  private clienteNotaFiscal;

  public controlsSettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'fontawesome',
    buttonClasses: 'btn btn-secondary btn-block',
    containerClasses: '',
    selectionLimit: 1,
    dynamicTitleMaxItems: 1,
    autoUnselect: true,
    showUncheckAll: true
  };

  constructor(
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private modalService: NgbModal,
    private solicitacaoService: GerarSolicitacaoService,
    private consultaPreviaService: ConsultaPreviaService,
    private dropdownlistService: DropdownListService,
    private toastr: ToastrService,
    private auth: AuthenticationService,
    private contatoComercialService: ContatoComercialService,
    private endpointLocationService: EndpointLocationProviderService,
    private router: Router,
    private zone: NgZone
  ) {
  }

  public getConfigSelectTexts(title: string) {
    const controlsText: IMultiSelectTexts = {
      uncheckAll: 'Desmarcar',
      searchPlaceholder: 'Procurar',
      searchEmptyResult: 'Nada encontrado...',
      searchNoRenderText: 'Digite para ver resultados...',
      defaultTitle: title
    };
    return controlsText;
  }

  private loadACs() {
    // Delay em 0 para evitar erros de lifecycle
    this.dropdownlistService.getAutoridadeCertificadoraDropdownList().pipe(delay(0)).subscribe(acList => {
      this.listaACs = acList;
      // Caso tenha permissão em apenas uma AC
      if (this.listaACs.length < 2) {
        this.dadosIdentificacaoTitular.get('IdAutoridadeCertificadora').setValue(this.listaACs[0].idAutoridadeCertificadora);
        this.dadosIdentificacaoTitular.get('IdAutoridadeCertificadora').disable();
      } else {
        this.dadosIdentificacaoTitular.get('IdAutoridadeCertificadora').setValue(-1);
      }
    });
  }

  onChangeAC(idAutoridadeCertificadora: number) {
    this.selectAutoridadeRegistro.uncheckAll();

    if (idAutoridadeCertificadora > 0) {

      // Carrega as ARs
      this.dropdownlistService.getAutoridadeRegistroDropdownListByAC(idAutoridadeCertificadora).subscribe(result => {
        if (result) {
          this.listaARs = result;

          this.listaARs = this.listaARs.map(x => {
            return { id: x.idAutoridadeRegistro, name: x.Nome };
          });

          this.listaAutoridadeRegistrosLoaded();
        }
      });
    } else {
      this.listaProdutosFiltro = [];
      this.listaARs = [];
    }
  }

  onChangeAR(idAutoridadeRegistro) {
    this.selectProduto.uncheckAll();
    this.listaProdutosFiltro = [];

    if (idAutoridadeRegistro > 0) {

      this.solicitacaoService.getListProdutoByACAR(this.dadosIdentificacaoTitular.get('IdAutoridadeCertificadora').value, idAutoridadeRegistro, this.paginaPai ? this.paginaPai.Nome : null).subscribe(result => {
        if (result) {
          this.listaProdutos = result;
          this.listaProdutos = this.listaProdutos.filter(x => x.Status === true && x.Codigo != null);

          this.listaProdutosFiltro = this.listaProdutos.map(x => {
            return { id: x.Codigo, name: x.Nome + ` (${x.Descricao})` };
          });

          this.listaProdutosLoaded();
        }
      });
    }
  }

  onChangeProduto(codigo) {
    if (codigo && codigo.length > 0) {
      const produtoSelecionado = this.listaProdutos.find(x => x.Codigo === codigo[0]);

      if (produtoSelecionado) {
        this.pagamento.get('NomeProduto').setValue(produtoSelecionado.Nome);
        this.pagamento.get('ValorProduto').setValue(produtoSelecionado.ValorCliente.toLocaleString('pt-BR', { minimumFractionDigits: 2 }));
        this.pagamento.get('Validade').setValue(produtoSelecionado.Descricao);
        this.pagamento.get('IdProduto').setValue(produtoSelecionado.idProduto);
        this.dadosIdentificacaoTitular.get('ProdutoTipoOriginal').setValue(produtoSelecionado.idProdutoTipo);

        switch (produtoSelecionado.idProdutoTipo) {
          case ProdutoTipoEnum.eCPF:
          case ProdutoTipoEnum.ePF:
            produtoSelecionado.idProdutoTipo = ProdutoTipoEnum.eCPF;
            break;
          case ProdutoTipoEnum.eCNPJ:
          case ProdutoTipoEnum.ePJ:
            produtoSelecionado.idProdutoTipo = ProdutoTipoEnum.eCNPJ;
            break;
          default:
            produtoSelecionado.idProdutoTipo = ProdutoTipoEnum.eCPF;
            break;
        }

        this.dadosIdentificacaoTitular.get('TipoProduto').setValue(produtoSelecionado.idProdutoTipo);

        // Ajuste necessário para que o validator do endereço da empresa funcione corretamente
        if (produtoSelecionado.idProdutoTipo === 2) {
          this.dadosIdentificacaoTitular.get('Endereco').enable();
        } else {
          this.dadosIdentificacaoTitular.get('Endereco').disable();
        }
      }
    }
  }

  private listaAutoridadeRegistrosLoaded() {
    if (!!this.paginaPai && !!this.paginaPai.Dados && !!this.paginaPai.Dados.Entidade.Objeto) {
      this.dadosIdentificacaoTitular.get('IdAutoridadeRegistro').setValue(!!this.paginaPai.Dados.Entidade.Objeto ? this.paginaPai.Dados.Entidade.Objeto.idAutoridadeRegistro : -1);
      this.paginaPai.Dados.Entidade.Objeto = null;
    }
  }

  private listaProdutosLoaded() {
    if (!!this.paginaPai && !!this.paginaPai.Dados && !!this.paginaPai.Dados.Produto) {
      this.dadosIdentificacaoTitular.get('Codigo').setValue(!!this.paginaPai.Dados.Produto ? this.paginaPai.Dados.Produto.Codigo : -1);
      this.paginaPai.Dados.Produto = null;
    }
  }

  private pegarDadosContatoComercial() {
    this.contatoComercialService.getListContatoComercial().subscribe(dados => {
      this.listaContatoComercial = dados;

      this.auth.getIdentityCPF().subscribe(res => {
        const contatoComercialSelecionado = this.listaContatoComercial.find(x => x.Usuario.CPF === res);

        if (contatoComercialSelecionado) {
          this.informacoesComerciais.patchValue({
            IdContatoComercial:
              contatoComercialSelecionado.IdContatoComercial,
          });
        } else {
          this.informacoesComerciais.patchValue({ IdContatoComercial: 0 });
        }
      });

    });
  }

  citiesListLoaded() {
    if (this.steps[1].active) {
      let group = null;
      if (!this.setouDadosNFe) {
        group = this.enderecoIdentificacao.getRawValue();
      } else {
        group = this.enderecoNota.getRawValue();
      }

      if (group && group.Endereco.Municipio && group.Endereco.Municipio.CodigoIBGE) {
        this.enderecoNota.get('Endereco.Municipio.CodigoIBGE').setValue(group.Endereco.Municipio.CodigoIBGE);
        // Patch nos dados faltantes do endereço
        this.enderecoNota.get('Endereco').patchValue({
          CEP: group.Endereco.CEP,
          Logradouro: group.Endereco.Logradouro,
          Numero: group.Endereco.Numero,
          Bairro: group.Endereco.Bairro,
          Complemento: group.Endereco.Complemento
        });

        this.setouDadosNFe = true;
      }
    } else if (this.clienteNotaFiscal && this.clienteNotaFiscal.CidadeCodigo) {
      this.enderecoNota.get('Endereco.Municipio.CodigoIBGE').setValue(this.clienteNotaFiscal.CidadeCodigo);
    }
  }

  countriesListLoaded() {
    if (this.steps[1].active) {
      let group = null;
      if (!this.setouDadosNFe) {
        group = this.enderecoIdentificacao.getRawValue();
      } else {
        group = this.enderecoNota.getRawValue();
      }

      if (group && group.Endereco.Municipio && group.Endereco.Municipio.UF && group.Endereco.Municipio.UF.Pais && group.Endereco.Municipio.UF.Pais.CodigoAlpha3) {
        this.enderecoNota.get('Endereco.Municipio.UF.Pais.CodigoAlpha3').setValue(group.Endereco.Municipio.UF.Pais.CodigoAlpha3);
      }
    } else if (this.clienteNotaFiscal && this.clienteNotaFiscal.PaisCodigoAlpha3) {
      this.enderecoNota.get('Endereco.Municipio.UF.Pais.CodigoAlpha3').setValue(this.clienteNotaFiscal.PaisCodigoAlpha3);
    }
  }

  statesListLoaded() {
    if (this.steps[1].active) {
      let group = null;
      if (!this.setouDadosNFe) {
        group = this.enderecoIdentificacao.getRawValue();
      } else {
        group = this.enderecoNota.getRawValue();
      }

      if (group && group.Endereco.Municipio && group.Endereco.Municipio.UF && group.Endereco.Municipio.UF.CodigoIBGE) {
        this.enderecoNota.get('Endereco.Municipio.UF.CodigoIBGE').setValue(group.Endereco.Municipio.UF.CodigoIBGE);
      }
    } else if (this.clienteNotaFiscal && this.clienteNotaFiscal.UFCodigo) {
      this.enderecoNota.get('Endereco.Municipio.UF.CodigoIBGE').setValue(this.clienteNotaFiscal.UFCodigo);
    }
  }

  citiesListLoadedEnderecoTitular() {
    if (this.endereco && this.endereco.Municipio && this.endereco.Municipio.CodigoIBGE && this.quantidadeLoadedCities < 2) {
      this.enderecoIdentificacao.get('Endereco.Municipio.CodigoIBGE').setValue(this.endereco.Municipio.CodigoIBGE);
      // Patch nos dados faltantes do endereço
      this.enderecoIdentificacao.get('Endereco').patchValue({
        CEP: this.endereco.CEP,
        Logradouro: this.endereco.Logradouro,
        Numero: this.endereco.Numero,
        Bairro: this.endereco.Bairro,
        Complemento: this.endereco.Complemento
      });

      // Ajuste necessário para controle do lifecycle ao carregar endereço do titular
      this.quantidadeLoadedCities++;
    }
  }

  statesListLoadedEnderecoTitular() {
    if (this.endereco && this.endereco.Municipio && this.endereco.Municipio.UF && this.endereco.Municipio.UF.CodigoIBGE && this.quantidadeLoadedStates < 2) {
      this.enderecoIdentificacao.get('Endereco.Municipio.UF.CodigoIBGE').setValue(this.endereco.Municipio.UF.CodigoIBGE);

      // Ajuste necessário para controle do lifecycle ao carregar endereço do titular
      this.quantidadeLoadedStates++;
    }
  }

  countriesListLoadedEnderecoTitular() {
    if (this.endereco && this.endereco.Municipio && this.endereco.Municipio.UF && this.endereco.Municipio.UF.Pais && this.endereco.Municipio.UF.Pais.CodigoAlpha3 && this.quantidadeLoadedCountries < 2) {
      this.enderecoIdentificacao.get('Endereco.Municipio.UF.Pais.CodigoAlpha3').setValue(this.endereco.Municipio.UF.Pais.CodigoAlpha3);

      // Ajuste necessário para controle do lifecycle ao carregar endereço do titular
      this.quantidadeLoadedCountries++;
    }
  }

  citiesListLoadedEnderecoEmpresa() {
    if (this.enderecoEmpresa && this.enderecoEmpresa.Municipio && this.enderecoEmpresa.Municipio.CodigoIBGE && this.quantidadeLoadedCitiesEmpresa < 2) {
      this.dadosIdentificacaoTitular.get('Endereco.Municipio.CodigoIBGE').setValue(this.enderecoEmpresa.Municipio.CodigoIBGE);
      // Patch nos dados faltantes do endereço
      this.dadosIdentificacaoTitular.get('Endereco').patchValue({
        CEP: this.enderecoEmpresa.CEP,
        Logradouro: this.enderecoEmpresa.Logradouro,
        Numero: this.enderecoEmpresa.Numero,
        Bairro: this.enderecoEmpresa.Bairro,
        Complemento: this.enderecoEmpresa.Complemento
      });

      // Ajuste necessário para controle do lifecycle ao carregar endereço da empresa
      this.quantidadeLoadedCitiesEmpresa++;
    }
  }

  statesListLoadedEnderecoEmpresa() {
    if (this.enderecoEmpresa && this.enderecoEmpresa.Municipio && this.enderecoEmpresa.Municipio.UF && this.enderecoEmpresa.Municipio.UF.CodigoIBGE && this.quantidadeLoadedStatesEmpresa < 2) {
      this.dadosIdentificacaoTitular.get('Endereco.Municipio.UF.CodigoIBGE').setValue(this.enderecoEmpresa.Municipio.UF.CodigoIBGE);

      // Ajuste necessário para controle do lifecycle ao carregar endereço da empresa
      this.quantidadeLoadedStatesEmpresa++;
    }
  }

  countriesListLoadedEnderecoEmpresa() {
    if (this.enderecoEmpresa && this.enderecoEmpresa.Municipio && this.enderecoEmpresa.Municipio.UF &&
      this.enderecoEmpresa.Municipio.UF.Pais && this.enderecoEmpresa.Municipio.UF.Pais.CodigoAlpha3 && this.quantidadeLoadedCountriesEmpresa < 2) {
      this.dadosIdentificacaoTitular.get('Endereco.Municipio.UF.Pais.CodigoAlpha3').setValue(this.enderecoEmpresa.Municipio.UF.Pais.CodigoAlpha3);

      // Ajuste necessário para controle do lifecycle ao carregar endereço da empresa
      this.quantidadeLoadedCountriesEmpresa++;
    }
  }

  private populaCamposNfe() {
    // identificação da nota
    this.dadosIdentificacaoTitular.get('TipoProduto').value === 1 ? this.dadosIdentificacaoNota.get('TipoDoc').setValue('CPF') : this.dadosIdentificacaoNota.get('TipoDoc').setValue('CNPJ');
    this.dadosIdentificacaoNota.get('Nome').setValue(this.dadosIdentificacaoTitular.get('NomeCompleto').value);
    this.dadosIdentificacaoNota.get('RazaoSocial').setValue(this.dadosIdentificacaoTitular.get('RazaoSocial').value);
    this.dadosIdentificacaoNota.get('CNPJ').setValue(this.dadosIdentificacaoTitular.get('CNPJ').value);
    this.dadosIdentificacaoNota.get('CPF').setValue(this.dadosIdentificacaoTitular.get('CPF').value);

    // dados de envio
    this.dadosEnvioNota.get('EmailPrincipal').setValue(this.dadosIdentificacaoTitular.get('Email').value);

    // endereço
    this.enderecoNota.get('Endereco.Municipio.UF.Pais.CodigoAlpha3').setValue(this.enderecoIdentificacao.get('Endereco.Municipio.UF.Pais.CodigoAlpha3').value);

    if (this.dadosIdentificacaoTitular.get('TipoProduto').value === 1) {
      this.dadosIdentificacaoNota.get('CheckIE').setValue(true);
    }
  }

  private criarIdentificacaoTitular() {
    this.dadosIdentificacaoTitular = this.formBuilder.group({
      IdAutoridadeCertificadora: [-1, Validators.required, IsOptionValidValidator.Validate],
      IdAutoridadeRegistro: [-1, Validators.required, IsOptionValidValidator.Validate],
      Codigo: [-1, Validators.required, IsOptionValidValidator.Validate],
      TipoProduto: [null],
      ProdutoTipoOriginal: [null],
      CPF: [null, Validators.required],
      DataNasc: [null, Validators.required],
      NomeCompleto: [null, Validators.required],
      Celular: [null, Validators.required],
      Email: [null, [Validators.compose([Validators.required, CustomValidators.email])]],

      CNPJ: [null, Util.conditionalValidator(() => this.dadosIdentificacaoTitular.get('TipoProduto').value === 2, Validators.required)],
      RazaoSocial: [null, Util.conditionalValidator(() => this.dadosIdentificacaoTitular.get('TipoProduto').value === 2, Validators.required)],
      NomeFantasia: [null],
      Telefone: [null, Util.conditionalValidator(() => this.dadosIdentificacaoTitular.get('TipoProduto').value === 2, Validators.required)],

      Endereco: this.formBuilder.group({
        idEndereco: [null],
        CEP: [null, Validators.compose([Validators.required, CustomValidators.min(8)])],
        Municipio: this.formBuilder.group({
          CodigoIBGE: [-1, Validators.required, IsOptionValidValidator.Validate],
          Nome: [''],
          UF: this.formBuilder.group({
            CodigoIBGE: [-1, Validators.required, IsOptionValidValidator.Validate],
            Sigla: [''],
            Pais: this.formBuilder.group({
              CodigoAlpha3: [-1, Validators.required, IsOptionValidValidator.Validate],
              Nome: ['']
            })
          })
        }),
        Logradouro: [null, IsNullOrEmptyValidator.Validate],
        Numero: [null, Validators.compose([IsNullOrEmptyValidator.Validate, Validators.pattern('^[a-zA-Z0-9 ]+$')])],
        Bairro: [null, IsNullOrEmptyValidator.Validate],
        Complemento: [null],
      })
    });
  }

  private criarDocumentoIdentidade() {
    this.tipoDocumentoIdentidade = this.formBuilder.group({
      TipoDocumento: [0],
      Numero: [null],
      Emissor: [null],
      EstadoDocumento: [null]
    });
  }

  private criarConectividadeSocial() {
    this.conectividadeSocial = this.formBuilder.group({
      NIS: [null],
      CEI: [null],
      CAEPF: [null]
    });
  }

  private criarTituloEleitor() {
    this.tituloEleitor = this.formBuilder.group({
      Numero: [null],
      Zona: [null],
      Secao: [null]
    });
  }

  private criarInformacoesComerciais() {
    this.informacoesComerciais = this.formBuilder.group({
      IdContatoComercial: ['0'],
      CPFContador: [null],
    });
  }

  private criarEnderecoIdentificacao() {
    this.enderecoIdentificacao = this.formBuilder.group({
      Endereco: this.formBuilder.group({
        idEndereco: [null],
        CEP: [null, Validators.compose([Validators.required, CustomValidators.min(8)])],
        Municipio: this.formBuilder.group({
          CodigoIBGE: [-1, Validators.required, IsOptionValidValidator.Validate],
          Nome: [''],
          UF: this.formBuilder.group({
            CodigoIBGE: [-1, Validators.required, IsOptionValidValidator.Validate],
            Sigla: [''],
            Pais: this.formBuilder.group({
              CodigoAlpha3: [-1, Validators.required, IsOptionValidValidator.Validate],
              Nome: ['']
            })
          })
        }),
        Logradouro: [null, IsNullOrEmptyValidator.Validate],
        Numero: [null, Validators.compose([IsNullOrEmptyValidator.Validate, Validators.pattern('^[a-zA-Z0-9 ]+$')])],
        Bairro: [null, IsNullOrEmptyValidator.Validate],
        Complemento: [null],
      })
    });
  }

  private criarIdentificacaoNota() {
    this.dadosIdentificacaoNota = this.formBuilder.group({
      TipoDoc: [null, Validators.required],
      Nome: [null, Validators.required],
      RazaoSocial: [null, Util.conditionalValidator(() => this.dadosIdentificacaoNota.get('TipoDoc').value === 'CNPJ', Validators.required)],
      CPF: [null, Validators.required],
      CNPJ: [null, Util.conditionalValidator(() => this.dadosIdentificacaoNota.get('TipoDoc').value === 'CNPJ', Validators.required)],
      InscricaoEstadual: ['', Validators.required],
      CheckIE: false
    });
  }

  private criarEnvioNota() {
    this.dadosEnvioNota = this.formBuilder.group({
      EmailPrincipal: [null, [Validators.compose([Validators.required, CustomValidators.email])]],
      EmailAlternativo: [null, CustomValidators.email]
    });
  }

  private criarEnderecoNota() {
    this.enderecoNota = this.formBuilder.group({
      Endereco: this.formBuilder.group({
        idEndereco: [null],
        CEP: [null, Validators.compose([Validators.required, CustomValidators.min(8)])],
        Municipio: this.formBuilder.group({
          CodigoIBGE: [-1, Validators.required, IsOptionValidValidator.Validate],
          Nome: [''],
          UF: this.formBuilder.group({
            CodigoIBGE: [-1, Validators.required, IsOptionValidValidator.Validate],
            Sigla: [''],
            Pais: this.formBuilder.group({
              CodigoAlpha3: [-1, Validators.required, IsOptionValidValidator.Validate],
              Nome: ['']
            })
          })
        }),
        Logradouro: [null, IsNullOrEmptyValidator.Validate],
        Numero: [null, Validators.compose([IsNullOrEmptyValidator.Validate, Validators.pattern('^[a-zA-Z0-9 ]+$')])],
        Bairro: [null, IsNullOrEmptyValidator.Validate],
        Complemento: [null],
      })
    });
  }

  private criarPagamento() {
    this.pagamento = this.formBuilder.group({
      TemVoucher: false,
      IdProduto: [null],
      VoucherCodigo: [''],
      ValorProduto: [''],
      VoucherValor: [null],
      NomeProduto: [''],
      Validade: [''],
      ValorNovo: [''],
      ValorDesconto: [''],
      ValorFormatado: [''],
      ValorPercentual: [''],
      VoucherPercentual: [null],
      Protocolo: [''],
      UrlBoleto: ['']
    });
  }

  private createSchedule() {
    this.schedule = this.formBuilder.group({
      date: ['', []],
      stateName: ['', []],
      cityName: ['', []],
      addressName: ['', []],
      localName: ['', []]
    });
  }

  // função para realizar a consulta previa dos dados do cliente;
  public onblurConsultaPrevia() {
    const consultaPrevia = new ConsultaPreviaModel();
    consultaPrevia.cpf = this.dadosIdentificacaoTitular.get('CPF').value;
    consultaPrevia.cnpj = this.dadosIdentificacaoTitular.get('CNPJ').value;
    consultaPrevia.dtNascimento = this.dadosIdentificacaoTitular.get('DataNasc').value;
    consultaPrevia.documentoTipo = 1;

    this.consultaPreviaService.realizarConsultaPrevia(consultaPrevia)
      .subscribe(
        dados => {
          if (dados.Codigo !== 0) {
            this.toastr.error(dados.Mensagem, 'Erro!', { disableTimeOut: true });
            this.dadosIdentificacaoTitular.get('NomeCompleto').setValue('');
            return false;
          }
          this.dadosIdentificacaoTitular.get('NomeCompleto').markAsTouched();
          this.dadosIdentificacaoTitular.get('NomeCompleto').setValue(dados.Mensagem);
        });
  }

  public onblurConsultaPreviaCNPJ() {
    const consultaPrevia = new ConsultaPreviaModel();
    consultaPrevia.cpf = this.dadosIdentificacaoTitular.get('CPF').value;
    consultaPrevia.cnpj = this.dadosIdentificacaoTitular.get('CNPJ').value;
    consultaPrevia.dtNascimento = this.dadosIdentificacaoTitular.get('DataNasc').value;
    consultaPrevia.documentoTipo = 2;

    this.consultaPreviaService.realizarConsultaPrevia(consultaPrevia)
      .subscribe(
        dados => {
          if (dados.Codigo !== 0) {
            this.toastr.error(dados.Mensagem, 'Erro!', { disableTimeOut: true });
            this.dadosIdentificacaoTitular.get('RazaoSocial').setValue('');
            this.dadosIdentificacaoTitular.get('NomeCompleto').setValue('');
            return false;
          }
          this.dadosIdentificacaoTitular.get('RazaoSocial').setValue(dados.Mensagem);
        });
  }

  removeCupom() {
    const pagamento = this.pagamento;

    if (!pagamento.get('Protocolo').value) {
      pagamento.get('ValorNovo').setValue('');
      pagamento.get('ValorDesconto').setValue('');
      pagamento.get('ValorFormatado').setValue('');
      pagamento.get('ValorPercentual').setValue('');
      pagamento.get('VoucherValor').setValue(null);
      pagamento.get('VoucherPercentual').setValue(null);
      pagamento.get('VoucherCodigo').setValue('');
      pagamento.get('TemVoucher').setValue(false);
    }
  }

  pegaCupom() {
    const obj = {
      numero: this.pagamento.get('VoucherCodigo').value,
      valor: this.pagamento.get('ValorProduto').value.replace(/\./g, '').replace(/\,/g, '.')
    };

    this.solicitacaoService.cupomDesconto(obj).subscribe(res => {
      this.retornoCupom = res;
      if (this.retornoCupom.Sucesso) {
        this.pagamento.get('TemVoucher').setValue(true);
        const voucher = {
          valorNovo: this.retornoCupom.ValorNovo,
          valorDesconto: this.retornoCupom.ValorDesconto,
          valorFormatado: this.retornoCupom.ValorFormatado,
          valorPercentual: this.retornoCupom.ValorPercentual,
          voucherPercentual: this.retornoCupom.VoucherPercentual
        };

        this.pagamento.get('ValorNovo').setValue(voucher.valorNovo);
        this.pagamento.get('ValorDesconto').setValue(voucher.valorDesconto);
        this.pagamento.get('ValorFormatado').setValue(voucher.valorFormatado);
        this.pagamento.get('ValorPercentual').setValue(voucher.valorPercentual);
        this.pagamento.get('VoucherPercentual').setValue(voucher.voucherPercentual);

        this.toastr.success('Cupom de desconto aplicado com sucesso!', 'Adicionado!');
      } else {
        this.pagamento.get('TemVoucher').setValue(false);
        this.messageService.handleMessage({
          title: 'Oops!',
          text: this.retornoCupom.Mensagem !== '' ? this.retornoCupom.Mensagem : 'Ocorreu um erro ao buscar o cupom de desconto!',
           icon: 'error'
        });
      }
    });
  }

  finalizar() {
    if (this.paginaPai != null) {
      this.modalService.dismissAll();
    } else {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate(['pages/comercial/solicitacao']);
    }
  }

  formataValor(valor) {
    if (valor) {
      return Number(valor.replace(/\./g, '').replace(/\,/g, '.')).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }

    return '';
  }

  // função para realizar a compra do produto.
  public comprar() {
    const pagamento = this.pagamento;

    if (pagamento.get('Protocolo').value) {
      const valorNovo = Number(pagamento.get('ValorNovo').value.replace(/\./g, '').replace(/\,/g, '.'));

      if ((valorNovo > 0 && pagamento.get('TemVoucher').value) || !pagamento.get('TemVoucher').value) {
        this.abrirModalSafe2Pay(this.pagamento.get('Protocolo').value);
        return;
      }
    }

    const dadosIdentificacaoTitular = this.dadosIdentificacaoTitular;
    const enderecoIdentificacao = this.enderecoIdentificacao;
    const informacoesComerciais = this.informacoesComerciais;
    const conectividadeSocial = this.conectividadeSocial;
    const tipoDocumentoIdentidade = this.tipoDocumentoIdentidade;
    const tituloEleitor = this.tituloEleitor;
    const dadosIdentificacaoNota = this.dadosIdentificacaoNota;
    const dadosEnvioNota = this.dadosEnvioNota;
    const enderecoNota = this.enderecoNota;

    const solicitacao = {
      ValorTotalBoleto: pagamento.get('TemVoucher').value ? pagamento.get('ValorNovo').value.replace(/\./g, '').replace(/\,/g, '.') : pagamento.get('ValorProduto').value.replace(/\./g, '').replace(/\,/g, '.'),
      VoucherCodigo: pagamento.get('TemVoucher').value ? pagamento.get('VoucherCodigo').value.trim() : null,
      VoucherValor: pagamento.get('TemVoucher').value ? pagamento.get('ValorDesconto').value : null,
      VoucherPercentual: pagamento.get('TemVoucher').value ? pagamento.get('VoucherPercentual').value : null,
      idAutoridadeRegistro: dadosIdentificacaoTitular.get('IdAutoridadeRegistro').value[0],
      TipoProduto: dadosIdentificacaoTitular.get('ProdutoTipoOriginal').value,
      idProduto: dadosIdentificacaoTitular.get('Codigo').value[0],
      CPFContador: informacoesComerciais.get('CPFContador').value,
      Nome: dadosIdentificacaoTitular.get('NomeCompleto').value,
      CPF: dadosIdentificacaoTitular.get('CPF').value,
      DataNascimento: dadosIdentificacaoTitular.get('DataNasc').value,
      CEI: conectividadeSocial.get('CEI').value,
      CAEPF: conectividadeSocial.get('CAEPF').value,
      idContatoComercial: informacoesComerciais.get('IdContatoComercial').value,
      RazaoSocial: dadosIdentificacaoTitular.get('RazaoSocial').value,
      NomeFantasia: dadosIdentificacaoTitular.get('NomeFantasia').value,
      CNPJ: dadosIdentificacaoTitular.get('CNPJ').value,

      Contato: {
        DDD: dadosIdentificacaoTitular.get('Celular').value.substring(0, 2),
        Telefone: dadosIdentificacaoTitular.get('Celular').value.substring(2),
        Email: dadosIdentificacaoTitular.get('Email').value
      },

      Endereco: {
        Logradouro: dadosIdentificacaoTitular.get('TipoProduto').value === 1 ? enderecoIdentificacao.get('Endereco.Logradouro').value : dadosIdentificacaoTitular.get('Endereco.Logradouro').value,
        Numero: dadosIdentificacaoTitular.get('TipoProduto').value === 1 ? enderecoIdentificacao.get('Endereco.Numero').value : dadosIdentificacaoTitular.get('Endereco.Numero').value,
        Complemento: dadosIdentificacaoTitular.get('TipoProduto').value === 1 ? enderecoIdentificacao.get('Endereco.Complemento').value : dadosIdentificacaoTitular.get('Endereco.Complemento').value,
        Bairro: dadosIdentificacaoTitular.get('TipoProduto').value === 1 ? enderecoIdentificacao.get('Endereco.Bairro').value : dadosIdentificacaoTitular.get('Endereco.Bairro').value,
        Cidade: dadosIdentificacaoTitular.get('TipoProduto').value === 1 ? enderecoIdentificacao.get('Endereco.Municipio.Nome').value : dadosIdentificacaoTitular.get('Endereco.Municipio.Nome').value,
        UF: dadosIdentificacaoTitular.get('TipoProduto').value === 1 ? enderecoIdentificacao.get('Endereco.Municipio.UF.Sigla').value : dadosIdentificacaoTitular.get('Endereco.Municipio.UF.Sigla').value,
        CEP: dadosIdentificacaoTitular.get('TipoProduto').value === 1 ? enderecoIdentificacao.get('Endereco.CEP').value : dadosIdentificacaoTitular.get('Endereco.CEP').value,
      },

      DocumentoIdentidade: {
        TipoDocumento: tipoDocumentoIdentidade.get('TipoDocumento').value,
        Numero: tipoDocumentoIdentidade.get('Numero').value ? tipoDocumentoIdentidade.get('Numero').value : null,
        Emissor: tipoDocumentoIdentidade.get('Emissor').value ? tipoDocumentoIdentidade.get('Emissor').value : null,
      },

      TituloEleitor: {
        Municipio: null,
        Numero: tituloEleitor.get('Numero').value,
        Secao: tituloEleitor.get('Secao').value,
        Zona: tituloEleitor.get('Zona').value
      },

      Titular: {
        Nome: dadosIdentificacaoTitular.get('NomeCompleto').value,
        CPF: dadosIdentificacaoTitular.get('CPF').value,
        DataNascimento: dadosIdentificacaoTitular.get('DataNasc').value,
        Contato: {
          DDD: dadosIdentificacaoTitular.get('Celular').value.substring(0, 2),
          Telefone: dadosIdentificacaoTitular.get('Celular').value.substring(2),
          Email: dadosIdentificacaoTitular.get('Email').value
        },
        Endereco: {
          Logradouro: enderecoIdentificacao.get('Endereco.Logradouro').value,
          Numero: enderecoIdentificacao.get('Endereco.Numero').value,
          Complemento: enderecoIdentificacao.get('Endereco.Complemento').value,
          Bairro: enderecoIdentificacao.get('Endereco.Bairro').value,
          Cidade: enderecoIdentificacao.get('Endereco.Municipio.Nome').value,
          UF: enderecoIdentificacao.get('Endereco.Municipio.UF.Sigla').value,
          CEP: enderecoIdentificacao.get('Endereco.CEP').value
        },

        DocumentoIdentidade: {
          TipoDocumento: tipoDocumentoIdentidade.get('TipoDocumento').value,
          Numero: tipoDocumentoIdentidade.get('Numero').value ? tipoDocumentoIdentidade.get('Numero').value : null,
          Emissor: tipoDocumentoIdentidade.get('Emissor').value ? tipoDocumentoIdentidade.get('Emissor').value : null,
        },

        TituloEleitor: {
          Municipio: null,
          Numero: tituloEleitor.get('Numero').value,
          Secao: tituloEleitor.get('Secao').value,
          Zona: tituloEleitor.get('Zona').value
        },

        NIS: conectividadeSocial.get('NIS').value
      },

      ClienteNotaFiscal: {
        Bairro: enderecoNota.get('Endereco.Bairro').value,
        CEP: enderecoNota.get('Endereco.CEP').value,
        Endereco: enderecoNota.get('Endereco.Logradouro').value,
        Complemento: enderecoNota.get('Endereco.Complemento').value,
        Numero: enderecoNota.get('Endereco.Numero').value,
        UF: enderecoNota.get('Endereco.Municipio.UF.Sigla').value,
        UFCodigo: enderecoNota.get('Endereco.Municipio.UF.CodigoIBGE').value,
        Pais: enderecoNota.get('Endereco.Municipio.UF.Pais.Nome').value,
        PaisCodigoAlpha3: enderecoNota.get('Endereco.Municipio.UF.Pais.CodigoAlpha3').value,
        Cidade: enderecoNota.get('Endereco.Municipio.Nome').value,
        CidadeCodigo: enderecoNota.get('Endereco.Municipio.CodigoIBGE').value,
        Documento: dadosIdentificacaoNota.get('TipoDoc').value === 'CPF' ? dadosIdentificacaoNota.get('CPF').value : dadosIdentificacaoNota.get('CNPJ').value,
        Email1: dadosEnvioNota.get('EmailPrincipal').value,
        Email2: dadosEnvioNota.get('EmailAlternativo').value,
        IE: dadosIdentificacaoNota.get('InscricaoEstadual').value,
        Sacado: dadosIdentificacaoNota.get('TipoDoc').value === 'CPF' ? dadosIdentificacaoNota.get('Nome').value : dadosIdentificacaoNota.get('RazaoSocial').value,
      }
    };

    this.addSolicitacao(solicitacao, pagamento);
  }

  private addSolicitacao(solicitacao, pagamento) {
    this.solicitacaoService.add(solicitacao, this.paginaPai ? this.paginaPai.Nome : null).subscribe(result => {
      this.retornoAdd = result;
      this.pagamento.get('Protocolo').setValue(this.retornoAdd.Protocolo);
      this.toastr.success('Protocolo gerado com sucesso!', 'Sucesso!');

      if ((Number(solicitacao.ValorTotalBoleto) > 0 && pagamento.get('TemVoucher').value) || !pagamento.get('TemVoucher').value && this.retornoAdd.AutoridadeRegistro) {
        this.CnpjAR = this.retornoAdd.AutoridadeRegistro.Documento;
        this.abrirModalSafe2Pay(this.retornoAdd.Protocolo);
      } else {
        this.next();
      }
    });
  }

  private abrirModalSafe2Pay(protocolo) {
    const componentSafe2Pay = document.querySelector('safe2pay-form') as any;
    const dadosIdentificacaoNota = this.dadosIdentificacaoNota;
    const enderecoNota = this.enderecoNota;
    const dadosEnvioNota = this.dadosEnvioNota;
    const informacoesComerciais = this.informacoesComerciais;

    const contatoComercialSelecionado = this.listaContatoComercial.find(x => x.IdContatoComercial === informacoesComerciais.get('IdContatoComercial').value);
    let apelidoContatoComercial = '';

    if (contatoComercialSelecionado) {
      apelidoContatoComercial = contatoComercialSelecionado.Apelido;
    }

    const parametrosCompra = {
      Products: [{
        Code: this.dadosIdentificacaoTitular.get('Codigo').value[0],
        Description: this.pagamento.get('NomeProduto').value + ' - ' + this.pagamento.get('Validade').value,
        UnitPrice: this.pagamento.get('TemVoucher').value ? this.pagamento.get('ValorNovo').value.replace(/\./g, '').replace(/\,/g, '.') : this.pagamento.get('ValorProduto').value.replace(/\./g, '').replace(/\,/g, '.'),
        Quantity: 1
      }],

      Customer: {
        Name: dadosIdentificacaoNota.get('TipoDoc').value === 'CPF' ? dadosIdentificacaoNota.get('Nome').value : dadosIdentificacaoNota.get('RazaoSocial').value,
        Identity: dadosIdentificacaoNota.get('TipoDoc').value === 'CPF' ? dadosIdentificacaoNota.get('CPF').value : dadosIdentificacaoNota.get('CNPJ').value,
        Email: dadosEnvioNota.get('EmailPrincipal').value,
        Address: {
          ZipCode: enderecoNota.get('Endereco.CEP').value,
          Street: enderecoNota.get('Endereco.Logradouro').value,
          Number: enderecoNota.get('Endereco.Numero').value,
          Complement: enderecoNota.get('Endereco.Complemento').value,
          District: enderecoNota.get('Endereco.Bairro').value,
          CityName: enderecoNota.get('Endereco.Municipio.Nome').value,
          StateInitials: enderecoNota.get('Endereco.Municipio.UF.Sigla').value,
          CountryName: enderecoNota.get('Endereco.Municipio.UF.Pais.Nome').value,
        }
      },
      Application: 'CERTIFICACAO',
      Vendor: apelidoContatoComercial,
      Reference: protocolo,
      Instruction: this.pagamento.get('NomeProduto').value + ' - ' + this.pagamento.get('Validade').value + ' :: Protocolo :: ' + protocolo,
      CallbackUrl: this.solicitacaoService.getUrlNotificacao(protocolo),
      Cnpj: this.CnpjAR,
      UpdatePagamento: true
    };

    componentSafe2Pay.openSafe2Pay(parametrosCompra, this.finalizarSafe2Pay.bind(this)).then(() => {
      this.next();
    });
  }

  private finalizarSafe2Pay(response) {
    this.pagamento.get('UrlBoleto').setValue(response.detail.BankSlipUrl);
  }

  sendEmail() {
    const dadosEmail = {
      idProduto: this.pagamento.get('IdProduto').value,
      idAutoridadeCertificadora: this.dadosIdentificacaoTitular.get('IdAutoridadeCertificadora').value,
      destinatario: this.dadosEnvioNota.get('EmailPrincipal').value !== '' ? this.dadosEnvioNota.get('EmailPrincipal').value : this.dadosEnvioNota.get('EmailAlternativo').value,
      urlBoleto: this.pagamento.get('UrlBoleto').value,
      protocolo: this.pagamento.get('Protocolo').value
    };

    this.solicitacaoService.sendEmail(dadosEmail, this.paginaPai ? this.paginaPai.Nome : null).subscribe(res => {
      if (res) {
        this.toastr.success('Informações enviadas para o seu e-mail!', 'Sucesso!');
      }
    });
  }

  // consulta contador parceiro
  buscaContador(cpfContador) {
    const cpf = cpfContador.replace(/[^0-9]/g, '');
    this.solicitacaoService.consultaContador(cpf).subscribe(res => {
      if (!res) {
        this.toastr.warning('Contador não encontrado!', 'Atenção!', { disableTimeOut: true });
        this.informacoesComerciais.get('CPFContador').setValue(null);
      }
    });
  }

  // faz a verificação do isento
  onChangeIE(value) {
    if (value) {
      this.dadosIdentificacaoNota.get('InscricaoEstadual').setValue('');
      this.dadosIdentificacaoNota.get('InscricaoEstadual').disable();
    } else {
      this.dadosIdentificacaoNota.get('InscricaoEstadual').enable();
    }
  }

  showSchedule() {
    const pagamento = this.pagamento;
    const configs = {
      Protocolo: pagamento.get('Protocolo').value,
      ExibirAvisos: true,
      CnpjAR: ''
    };

    const componentSchedule = document.querySelector('agendamento-webcomponent') as any;

    componentSchedule.showSchedule(configs, res => {
      if (res.Codigo === 1) {
        this.zone.run(() => {
          this.schedule.get('stateName').setValue(res.Estado);
          this.schedule.get('cityName').setValue(res.Cidade);
          this.schedule.get('addressName').setValue(res.Endereco);
          this.schedule.get('localName').setValue(res.Local);
          this.schedule.get('date').setValue(res.DataAgendamento);
          this.next();
        });
      }
    });
  }

  // funções que realizam os steps.
  next() {
    const dadosIdentificacaoTitular = this.dadosIdentificacaoTitular;
    const enderecoIdentificacao = this.enderecoIdentificacao;
    const dadosIdentificacaoNota = this.dadosIdentificacaoNota;
    const dadosEnvioNota = this.dadosEnvioNota;
    const enderecoNota = this.enderecoNota;

    if (this.steps[this.steps.length - 1].active) {
      return false;
    }

    this.steps.some((step, index, steps) => {
      if (index < steps.length - 1) {
        if (step.active) {
          switch (step.name) {
            case 'Identificação':
              if (dadosIdentificacaoTitular.valid && enderecoIdentificacao.valid) {

                if (!this.setouDadosNFe) {
                  this.populaCamposNfe();
                }

                step.active = false;
                step.valid = true;
                steps[index + 1].active = true;
                return true;
              } else {
                step.hasError = true;
              }
              break;

            case 'Nota Fiscal':
              if (dadosIdentificacaoNota.valid && dadosEnvioNota.valid && enderecoNota.valid) {
                step.active = false;
                step.valid = true;
                steps[index + 1].active = true;
                return true;
              } else {
                step.hasError = true;
              }
              break;

            case 'Pagamento':
              this.sendEmail(); //Remover caso liberar step agendamento
              //this.showSchedule(); //Descomentar caso liberar step agendamento
              step.active = false;
              step.valid = true;
              steps[index + 1].active = true;
              return true;
            // case 'Agendamento':
            //   this.sendEmail();
            //   step.active = false;
            //   step.valid = true;
            //   steps[index + 1].active = true;
            //   return true;
            case 'Pronto':
              
              step.active = false;
              step.valid = true;
              steps[index + 1].active = true;
              return true;
            default:
              break;
          }
        }
      }
    });
  }

  prev() {
    if (this.steps[0].active) {
      return false;
    }

    this.steps.some(function (step, index, steps) {
      if (index !== 0) {
        if (step.active) {
          step.active = false;
          steps[index - 1].active = true;
          return true;
        }
      }
    });
  }

  setSolicitacaoData() {
    if (this.paginaPai != null) {

      this.toastr.warning('Valide o e-mail do titular!', 'Lembrete!', { disableTimeOut: true });

      this.solicitacaoService.get(this.paginaPai.Protocolo).subscribe(result => {
        this.paginaPai.Dados = result;

        if (result.DadosTitular) {
          this.dadosIdentificacaoTitular.patchValue({
            IdAutoridadeCertificadora: result.Produto.AutoridadeCertificadora ? result.Produto.AutoridadeCertificadora.idAutoridadeCertificadora : this.listaACs[0].idAutoridadeCertificadora,
            CPF: result.DadosTitular.CPF,
            DataNasc: Util.dateIsValid(result.DadosTitular.DtNascimento) ? Util.convertDataToUTC(result.DadosTitular.DtNascimento) : null,
            NomeCompleto: result.DadosTitular.Nome,
            Celular: result.DadosTitular.Contato.DDD + result.DadosTitular.Contato.Telefone,
            Email: result.DadosTitular.Contato.Email,
          });

          this.onblurConsultaPrevia();

          this.endereco = result.DadosTitular.Endereco;
          this.enderecoIdentificacao.get('Endereco.Municipio.UF.Pais.CodigoAlpha3').setValue(this.endereco.Municipio.UF.Pais.CodigoAlpha3);

          if (result.DadosTitular.DocumentoIdentidade) {
            this.tipoDocumentoIdentidade.patchValue(result.DadosTitular.DocumentoIdentidade);
          }

          this.conectividadeSocial.patchValue(result.DadosTitular);

          if (result.DadosTitular.TituloEleitor) {
            this.tituloEleitor.patchValue({
              Numero: result.DadosTitular.TituloEleitor.Titular_EleitorNumero,
              Zona: result.DadosTitular.TituloEleitor.Titular_EleitorZona,
              Secao: result.DadosTitular.TituloEleitor.Titular_EleitorSecao,
            });
          }
        }

        if (result.DadosEmpresa) {
          this.dadosIdentificacaoTitular.patchValue({
            CNPJ: result.DadosEmpresa.CNPJ,
            RazaoSocial: result.DadosEmpresa.RazaoSocial,
            NomeFantasia: result.DadosEmpresa.NomeFantasia,
            Telefone: result.DadosEmpresa.Contato.DDD + result.DadosEmpresa.Contato.Telefone,
          });

          this.onblurConsultaPreviaCNPJ();

          this.enderecoEmpresa = result.DadosEmpresa.Endereco;
          this.dadosIdentificacaoTitular.get('Endereco.Municipio.UF.Pais.CodigoAlpha3').setValue(this.enderecoEmpresa.Municipio.UF.Pais.CodigoAlpha3);
        }

        this.informacoesComerciais.patchValue({
           CPFContador: result.Parametro25,
           IdContatoComercial: result.ContatoComercial ? result.ContatoComercial.IdContatoComercial :  0
          });

        if (result.ClienteNotaFiscal) {
          this.setouDadosNFe = true;

          const clienteNotaFiscal = result.ClienteNotaFiscal;
          const isCpf = clienteNotaFiscal.Documento && clienteNotaFiscal.Documento.length === 11;

          this.enderecoNota.get('Endereco').patchValue({
            CEP: clienteNotaFiscal.Cep,
            Logradouro: clienteNotaFiscal.Endereco,
            Numero: clienteNotaFiscal.Numero,
            Bairro: clienteNotaFiscal.Bairro,
            Complemento: clienteNotaFiscal.Complemento,
          });

          this.dadosIdentificacaoNota.patchValue({
            TipoDoc: isCpf ? 'CPF' : 'CNPJ',
            Nome: clienteNotaFiscal.Sacado,
            RazaoSocial: clienteNotaFiscal.Sacado,
            CPF: isCpf ? clienteNotaFiscal.Documento : null,
            CNPJ: !isCpf ? clienteNotaFiscal.Documento : null,
            InscricaoEstadual: clienteNotaFiscal.IE,
            CheckIE: !clienteNotaFiscal.IE ? true : false
          });

          this.dadosEnvioNota = this.formBuilder.group({
            EmailPrincipal: clienteNotaFiscal.Email1,
            EmailAlternativo: clienteNotaFiscal.Email2
          });

          this.clienteNotaFiscal = clienteNotaFiscal;
          this.enderecoNota.get('Endereco.Municipio.UF.Pais.CodigoAlpha3').setValue(clienteNotaFiscal.PaisCodigoAlpha3);
        }
      });
    }
  }

  ngAfterViewInit() {
    this.pegarDadosContatoComercial();
    this.loadACs();
    this.setSolicitacaoData();
  }

  ngOnInit() {
    this.env = environment;

    this.createS2P();
  
    //Descomentar caso liberar step agendamento
    //this.createScheduleWebcomponent();

    this.steps = [
      { name: 'Identificação', icon: 'fa-user', active: true, valid: false, hasError: false },
      { name: 'Nota Fiscal', icon: 'fa-address-card', active: false, valid: false, hasError: false },
      { name: 'Pagamento', icon: 'fa-file-text', active: false, valid: false, hasError: false },
      //Descomentar caso liberar step agendamento
      //{ name: 'Agendamento', icon: 'fa-calendar', active: false, valid: false, hasError: false },
      { name: 'Pronto', icon: 'fa-check-circle', active: false, valid: false, hasError: false }
    ];

    // steps identificação
    this.criarIdentificacaoTitular();
    this.criarDocumentoIdentidade();
    this.criarConectividadeSocial();
    this.criarTituloEleitor();
    this.criarInformacoesComerciais();
    this.criarEnderecoIdentificacao();

    // steps Nota Fiscal
    this.criarIdentificacaoNota();
    this.criarEnderecoNota();
    this.criarEnvioNota();

    // step pagamento
    this.criarPagamento();

    // step agendamento
    this.createSchedule();

    this.dadosIdentificacaoTitular.get('TipoProduto').valueChanges
      .subscribe(() => {
        this.dadosIdentificacaoTitular.get('Endereco').updateValueAndValidity();
        this.dadosIdentificacaoTitular.get('CNPJ').updateValueAndValidity();
        this.dadosIdentificacaoTitular.get('RazaoSocial').updateValueAndValidity();
        this.dadosIdentificacaoTitular.get('Telefone').updateValueAndValidity();
      });

    this.dadosIdentificacaoNota.get('TipoDoc').valueChanges
      .subscribe(() => {
        this.dadosIdentificacaoNota.get('CNPJ').updateValueAndValidity();
        this.dadosIdentificacaoNota.get('RazaoSocial').updateValueAndValidity();
      });
  }

  public createS2P() {
    const src = `${this.endpointLocationService.getEndpointURI(this.env.URL_WEBCOMPONENT_SAFE2PAY)}`;

    const script = document.createElement('script');
    script.setAttribute('src', src);
    document.body.appendChild(script);
  }

  public createScheduleWebcomponent() {
    const src = `${this.endpointLocationService.getEndpointURI(this.env.URL_WEBCOMPONENT_AGENDAMENTO)}`;

    const script = document.createElement('script');
    script.setAttribute('src', src);
    document.body.appendChild(script);
  }
}
